import { inject, Injectable } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { PolicyForm, PolicyStatusType } from '@features/insured/models/policy/policy.model'
import { buildAlbertValueObjectGroup } from '@core/utils/form-utils'
import { CoverageInsuranceType } from '@shared/models/coverage-insurance.model'

@Injectable({
  providedIn: 'root'
})
export class PolicyFormService {
  private readonly fb = inject(FormBuilder)

  public buildForm(required = false): FormGroup<PolicyForm> {
    return this.fb.group({
      uuid: this.fb.control<string | null>(null, { validators: [required ? Validators.required : Validators.nullValidator] }),
      externalId: this.fb.control<string | null>(null),
      memberId: this.fb.control<string | null>(null),
      periodId: this.fb.control<string | null>(null),
      coverageType: buildAlbertValueObjectGroup<CoverageInsuranceType>(this.fb, null),
      status: this.fb.control<PolicyStatusType | null>(null),
      coInsurance: this.fb.control<string | null>(null),
    }, { updateOn: 'blur' }) as FormGroup<PolicyForm>
  }

  public applyCreateDefaults(form: FormGroup<PolicyForm>): void {
    form.reset()
    form.patchValue({
      uuid: null,
      status: 'PROPOSAL',
      coverageType: {
        localValue: null
      }
    })
  }
}
